<template>
  <div class="main">
    <Header
      :show="true"
      :title="docTitle"
      left="prepage"
      right=""
      :click-left="handleClickLeft"
    />
    <div style="padding-bottom: 8vh">
      <div
        v-if="loading"
        style="
          width: 100%;
          margin-top: 100px;
          display: flex;
          justify-content: center;
        "
      >
        <van-loading
          type="spinner"
          color="#ed6a0c"
        />
      </div>
      <div v-else>
        <div>
          <div
            style="
              display: flex;
              justify-content: space-between;
              padding: 12px;
              align-items: center;
            "
          >
            <div style="font-size: 14px">
              申领物品
            </div>
            <van-button
              type="info"
              size="small"
              @click="visibleAdd = true"
            >
              选择物品
            </van-button>
          </div>
          <van-cell-group>
            <van-cell
              v-if="editValues.stockDetailList.length === 0"
              title="未选择出库物品"
              value="请点击上方按钮选择"
            />
            <van-cell
              v-for="item in editValues.stockDetailList"
              :key="item.materialId"
              :title="materialNameMap[item.materialId]"
            >
              <template slot="default">
                <div style="display: flex; justify-content: flex-end">
                  <van-stepper
                    v-model="item.outNum"
                    :min="1"
                    integer
                    input-width="60"
                  />
                  <span
                    style="margin-left: 6px; color: red"
                    @click="
                      editValues.stockDetailList =
                        editValues.stockDetailList.filter(
                          (listV) => listV !== item
                        )
                    "
                  >移除</span>
                </div>
              </template>
            </van-cell>
          </van-cell-group>
          <div style="margin-top: 12px">
            <van-field
              v-model="editValues.remark"
              placeholder="请输入备注信息"
            />
          </div>
          <div style="padding: 12px">
            <van-button
              :loading="submitLoading"
              block
              type="info"
              @click="submit"
            >
              {{ docTitle }}
            </van-button>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      v-model="visibleAdd"
      position="bottom"
    >
      <div style="background-color: white">
        <div style="font-size: 16px; text-align: center; padding: 12px">
          录入产品
        </div>
        <div>
          <van-search
            v-model="searchKey"
            placeholder="请输入搜索关键词"
          />
          <van-cell-group style="height: 400px; overflow-y: auto">
            <van-cell
              v-for="item in renderMaterialList"
              :key="item.id"
              :title="item.name"
              is-link
              arrow-direction="right"
              @click="handleAddItem(item)"
            />
          </van-cell-group>
        </div>
      </div>
    </van-popup>
    <Footer
      :show="false"
      value="service"
    />
  </div>
</template>

<script>
import { findById, edit } from "@/api/wms/outStock";
import { getList as getMaterialList } from "@/api/wms/materialInfo";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

const initFormValue = {
  stockDetailList: [],
  remark: "",
};

export default {
  components: {
    Header,
    Footer,
  },
  data: () => ({
    loading: false,
    submitLoading: false,
    visibleAdd: false,
    docTitle: "",
    searchKey: "",
    materialList: [],
    editValues: initFormValue,
  }),
  computed: {
    materialNameMap() {
      return this.materialList.reduce((prev, item) => {
        prev[item.id] = item.name;
        return prev;
      }, {});
    },
    renderMaterialList() {
      if (!this.searchKey) return this.materialList;
      return this.materialList.filter((item) => {
        if (typeof item.name !== "string") return false;
        return item.name.includes(this.searchKey);
      });
    },
  },
  created() {
    this.getMaterialList();
    const row = this.$route.query ?? {};
    if (row.id) {
      this.searchItem(row.id);
      this.docTitle = "编辑申请";
    } else {
      this.docTitle = "创建申请";
    }
  },
  methods: {
    handleClickLeft() {
      this.$router.go(-1);
    },
    async getMaterialList() {
      const param = {
        page: { current: 1, size: 1000 },
      };
      const { data } = await getMaterialList(param);

      if (data.code === 2000) {
        const result = data.data;
        this.materialList = result.records;
      }
    },
    async searchItem(id) {
      this.loading = true;
      const { data } = await findById(id).finally(() => (this.loading = false));
      if (data.code === 2000) {
        const result = data.data;
        this.editValues = {
          id: result.id,
          stockDetailList: result.stockDetailList,
          remark: result.remark,
        };
      }
    },
    handleAddItem(value) {
      const list = this.editValues.stockDetailList;
      const inList = list.some((item) => item.materialId === value.id);
      if (inList) {
        this.$toast.fail({ message: "请勿重复添加物品" });
      } else {
        this.editValues.stockDetailList.push({
          materialId: value.id,
          outNum: 1,
        });
      }
    },
    async submit() {
      const payload = {
        ...this.editValues,
      };

      if (payload.stockDetailList.length === 0) {
        this.$toast.fail({ message: "请在选择出库产品后提交" });
        return
      }
      this.submitLoading = true;
      const { data } = await edit(payload).finally(
        () => (this.submitLoading = false)
      );
      if (data.code === 2000) {
        this.$toast.success({ message: "操作成功", mask: true });
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 系统样式修改
::v-deep .van-field__label {
  width: 5em;
}
::v-deep .van-checkbox {
  padding: 3px 0;
}
::v-deep .van-checkbox__icon {
  font-size: 4.5vw;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #f9f9f9; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
